<template>
  <form name="publications-form" @submit.prevent="$emit('save')">
    <BLayoutExpansion title="Основное" class="my-4">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-row dense>
            <v-col cols="9">
              <BFileInput
                :value="form.file"
                :accept="accept"
                small-chips
                show-size
                validate="required"
                hide-details="auto"
                outlined
                label="Файл"
                @change="(file) => form.file = file"
              />
            </v-col>
            <v-col
              cols="3"
              style="display: flex; align-items: center;"
            >
              <v-btn color="primary" small :disabled="isLoadingPostProcess" @click.stop="onFileUpload">
                Загрузить
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="!!fileDownloadable.name" dense>
        <v-col cols="12" md="6">
          <v-row dense>
            <v-col cols="9" style="padding-left: 32px;">
              <a
                class="MarksFileLink"
                @click.stop="onFileDownload"
              >{{ fileDownloadable.name }}</a>
            </v-col>
            <v-col
              cols="3"
              style="display: flex; align-items: center;"
            >
              <v-btn
                color="primary"
                small
                :loading="isLoadingPostProcess"
                :disabled="isLoadingPostProcess"
                @click.stop="onFileProcess"
              >
                Обработать
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <slot name="save-menu" />
    </BLayoutExpansion>

    <button type="submit" class="d-none" />
  </form>
</template>

<script>
import BFileInput from '@/components/forms/BFileInput.vue'
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'

import { toLower, toString } from 'lodash'
import { downloadLinkByGet } from '@/helpers/downloadBlob'
import { createMarksFileUploadModal, MARKS_ROUTES as ROUTES } from '../utils'
import {
  MarksApi, VeersApi, QuestionsApi, MarksFilesApi, MarksProceduresApi, TasksOrderApi,
} from '@/api/resources/Marks'

const createDefaultData = () => ({
  file: null,
})

export default {
  name: 'MarksUploadForm',
  components: {
    BFileInput,
    BLayoutExpansion,
  },
  extends: BLayoutForm,
  props: {
    skeleton: Boolean,
    loading: Boolean,
    data: {
      type: Object,
      default: createDefaultData,
    },
  },
  data: () => ({
    fileDownloadable: {
      name: null,
      id: null,
    },
    isLoadingPostProcess: false,
  }),
  computed: {
    isVeerForm() {
      const { which } = this.$route.query
      return which === 'VEER'
    },
    accept() {
      const { isVeerForm } = this
      if (isVeerForm) {
        return ['.xlsx', '.xls']
      }
      return '.csv'
    },
  },
  async created() {
    const api = new MarksProceduresApi()
    const { procedure_id, which } = this.$route.query
    const { data } = await api.getOne(procedure_id)
    const targetKey = toLower(which)
    console.log(targetKey)
    if (data[`${targetKey}_file_filename`] && data[`${targetKey}_file_id`]) {
      this.fileDownloadable = {
        id: data[`${targetKey}_file_id`],
        name: data[`${targetKey}_file_filename`],
      }
    }
  },
  methods: {
    async onSubmit() {
      const result = await this.$validator.validate()
      if (!result) {
        return
      }

      await this.onFileUpload()
      await this.onFileProcess()
    },
    onFileDownload() {
      const fApi = new MarksFilesApi()
      downloadLinkByGet(fApi.download(this.fileDownloadable.id), this.fileDownloadable.name)
    },
    async onFileProcess() {
      // const result = await this.$validator.validate()
      // if (!result) {
      //   return
      // }

      const { procedure_id, which } = this.$route.query

      let api = null
      switch (which) {
        case 'MARKS':
          api = new MarksApi()
          break
        case 'VEER':
          api = new VeersApi()
          break
        case 'QUESTIONS':
          api = new QuestionsApi()
          break
        case 'TASKS_ORDER':
          api = new TasksOrderApi()
          break
        default:
          this.$notice.warning(`Неизвестный тип ${which}`)
          return
      }
      try {
        const body = {
          procedure_id: toString(procedure_id),
        }
        this.isLoadingPostProcess = true
        await api.parse(body)

        this.$notice.info(
          'Файл обрабатывается. После завершения обработки файла, синхронизации ключей и ответов участников вы получите сообщение в разделе уведомлений.',
        )
        this.$router.push({
          name: ROUTES.LIST,
        })
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoadingPostProcess = false
      }
    },
    async onFileUpload() {
      const result = await this.$validator.validate()
      if (!result) {
        return
      }

      try {
        const modal = await createMarksFileUploadModal(this, {
          procedureId: this.$route.query.procedure_id,
          on: {
            success: (file_id) => {
              this.fileDownloadable = {
                name: this.form.file.name,
                id: file_id,
              }
            },
          },
        })
        await modal.open(this.form.file)
      } catch (e) {
        this.$notice.errors(e)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.MarksFileLink {
  font-size: 0.8rem;
  font-style: italic;
  color: $color-info;
  text-decoration: underline;
}
</style>
